var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Capa'),_c('Sobre'),_c('Comofunciona'),_c('Preco'),_c('Experimente'),_c('Contato')],1)}
var staticRenderFns = []

export { render, staticRenderFns }